import React, { useState, useEffect, useRef } from 'react';
import posterImages from '../generated/posterManifest';

function normalizePosters(posters) {
  const desktop = posters.desktop?.length ? posters.desktop : posters.mobile || [];
  const mobile = posters.mobile?.length ? posters.mobile : desktop;
  const length = Math.max(desktop.length, mobile.length);

  return Array.from({ length }, (_, i) => ({
    desktop: desktop[i % desktop.length],
    mobile: mobile[i % mobile.length],
  })).filter(slide => slide.desktop || slide.mobile);
}

function CenterCarousel({ posters, interval, label }) {
  const [state, setState] = useState({ cur: 0, next: null, animating: false });
  const stateRef = useRef(state);
  stateRef.current = state;
  const slides = normalizePosters(posters);

  useEffect(() => {
    if (slides.length <= 1) return;
    const t = setInterval(() => {
      const { cur, animating } = stateRef.current;
      if (animating) return;
      const next = (cur + 1) % slides.length;
      setState({ cur, next, animating: true });
      setTimeout(() => setState({ cur: next, next: null, animating: false }), 700);
    }, interval);
    return () => clearInterval(t);
  }, [slides.length, interval]);

  const { cur, next, animating } = state;
  if (!slides.length) return <div className="hero-placeholder"><span>{label}</span></div>;

  return (
    <div className="hero-col-inner hero-center-col">
      {slides.map((slide, i) => {
        let slideClass = 'hero-slide';
        if (i === cur && !animating) slideClass += ' visible';
        else if (i === cur && animating) slideClass += ' hero-page-out';
        else if (i === next && animating) slideClass += ' hero-page-in';
        const desktopSrc = slide.desktop || slide.mobile;
        const mobileSrc = slide.mobile || desktopSrc;
        return (
          <picture key={`${desktopSrc}-${mobileSrc}`} className={slideClass}>
            <source media="(max-width: 768px)" srcSet={mobileSrc} />
            <img src={desktopSrc} alt="" className="hero-img" loading={i === 0 ? 'eager' : 'lazy'} />
          </picture>
        );
      })}
    </div>
  );
}

function HeroCarousel({ fullScreen = false }) {
  const [posters, setPosters] = useState(posterImages);

  useEffect(() => {
    let cancelled = false;

    fetch(`/posters/posters.php?v=${Date.now()}`, { cache: 'no-store' })
      .then(res => {
        if (!res.ok) throw new Error('Poster manifest unavailable');
        return res.json();
      })
      .then(data => {
        if (!cancelled && (data.desktop?.length || data.mobile?.length)) {
          setPosters(data);
        }
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className={`hero-carousel${fullScreen ? ' full-screen' : ''}`}>
      <div className="hero-col hero-col-center">
        <CenterCarousel posters={posters} interval={4000} label="Showcase" />
      </div>
    </div>
  );
}

export default HeroCarousel;
